<template>
	<header>
		<nav class="navbar navbar-black">
			<div class="container">
				<!-- Collect the nav links, forms, and other content for toggling -->
				<ul class="nav navbar-nav navbar-left hidden-xs">
					<li class="hidden-xs">
						<a style="padding-left: 0;" href="https://wa.me/523327482493" target="_blank">
							<i class="fa fa-whatsapp fa-fw" aria-hidden="true"></i>
							(33) 2748 2493
						</a>
					</li>
					<li class="hidden-sm">
						<a href="mailto:hola@lasddi.com">
							<i class="fa fa-envelope-o fa-fw" aria-hidden="true"></i>
							hola@lasddi.com
						</a>
					</li>
				</ul>

				<form class="navbar-form pull-right" @submit="search" role="search">
					<div class="right-inner-icon">
						<i class="fa fa-search fa-fw" aria-hidden="true"></i>
						<input type="text" class="form-control" v-model="query">
					</div>
				</form>

				<ul class="nav navbar-nav navbar-right">
					<!-- Change this to user current_user.token or .id to verify if the user is logged. -->
					<li v-if="!user.token">
						<a class="text-uppercase" v-link="{ path: '/registro' }">
							<span>Registrarme</span>
						</a>
					</li>
					<li v-if="user.token">
						<a class="text-uppercase" v-link="{ path: '/bienvenido' }">Bienvenido {{ user.user.name }}</a>
					</li>
					<li v-if="user.token">
						<a @click="logout">Cerrar sesión</a>
					</li>
					<li v-if="!user.token">
						<a style="padding-right: 15px;" v-link="{ path: '/login'}">
							Iniciar Sesión
						</a>
					</li>
					<li v-if="user.token">
						<a v-link="{ path: '/favoritos?page=1' }">
							<i class="fa fa-heart fa-fw" aria-hidden="true"></i>
						</a>
					</li>
					<li>
						<a v-link="{ path: '/carrito-de-compra' }" class="navbar-brand">
							<i class="fa fa-shopping-cart fa-fw" aria-hidden="true"></i>
							<span v-if="render_quantity">({{ render_quantity }})</span>
						</a>

						<div class="recently-added" v-if="show_recently_added">
							<ul class="shopping-cart-list">
								<li class="shopping-cart-item">
									<span class="product-prop product-name"><strong>Nombre</strong></span>
									<span class="product-prop product-quantity"><strong>Cantidad</strong></span>
									<span class="product-prop product-price"><strong>Precio</strong></span>
								</li>
								<li class="shopping-cart-item" v-for="product in products">
									<span class="product-prop product-name">{{ product.product.name }}</span>
									<span class="product-prop product-quantity">{{ product.quantity }}</span>
									<span class="product-prop product-price">{{ accounting.formatMoney(product.product.price) }}</span>
								</li>
								<li class="shopping-cart-total">
									<span class="total"><strong>Total:</strong></span>
									<span class="total">{{ showTotal(shopping_cart.total) }}</span>
								</li>
							</ul>

							<a class="btn btn-black btn-lg" @click.prevent="closeRecentlyAdded('/carrito-de-compra')">Ir al carrito</a>
							<div class="close-recently-added" @click="closeRecentlyAdded()"><i class="fa fa-close"></i></div>
						</div>
					</li>
				</ul>
			</div><!-- /.container-fluid -->
		</nav>
	</header>
</template>

<script>
import { logoutUser } from '../store/actions';
import { router } from '../routes/routes';
import accounting from '../scripts/accounting';

export default {
	data() {
		return {
			modalTimer: null,
			modalDuration: 4000,
			query: null,
			show_recently_added: false,
			accounting
		};
	},

	vuex: {
		getters: {
			shopping_cart: state => state.shopping_cart,
			products: state => state.shopping_cart.products,
			user: state => state.current_user
		},
		actions: {
			logoutUser
		}
	},

	methods: {
		logout() {
			this.logoutUser('/home');
		},

		search(e) {
			e.preventDefault();
			router.go({ path: '/resultados?page=1', query: { search: this.query }});
		},

		closeRecentlyAdded (route) {
			if (route) {
				this.$route.router.go(route);
			}

			clearTimeout(this.timer)
			this.show_recently_added = false;
		},

		showTotal (total) {
			var t = total || 0

			// If the shopping cart not has the total calculate here.
			if (!total) {
				for (let i = 0, p = this.shopping_cart.products; i < p.length; i++) {
					t += parseInt(p[i].quantity) * parseInt(p[i].product.price)
				}
			}

			return accounting.formatMoney(t)
		}
	},

	computed: {
		render_quantity() {
			let products = this.products || [];
			let quantity = 0;

			for (let i = 0; i < products.length; i++) {
				quantity += parseInt(products[i].quantity);
			}

			return quantity;
		},
	},

	ready: function () {
		window.App.$on('show-recently-added', e => {
			this.show_recently_added = true;

			this.modalTimer = setTimeout(() => {
				this.show_recently_added = false
			}, this.modalDuration)
		})
	}
}
</script>

<style scoped>
a {
	cursor: pointer;
}
a:hover i {
	color: gray!important;
}
a:hover {
	color: gray!important;
}
</style>



// WEBPACK FOOTER //
// Navigation.vue?2fedef5f